import isString from 'lodash/isString';

import { downloadAttachment } from 'dashboard/resources/announcements.api';

import template from './announcements-widget-content.html';

const mapStateToThis = ({ session, config, ui }) => {
  const { locale } = session;
  const { locales, jurisdictionId } = config;
  const { selectedLanguage } = ui;

  return {
    locale,
    locales,
    selectedLanguage,
    jurisdictionId,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$sce')
class AnnouncementsWidgetContentController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
    this.downloadAttachment = downloadAttachment;
  }

  $onInit() {
    this.language = this.selectedLanguage || this.locale;
    this.activeIndex = 0;
    this.selectedAnnouncement = this.items[this.activeIndex] || null;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onAnnouncementChange(announcement, index) {
    this.activeIndex = index;
    this.selectedAnnouncement = announcement;
  }

  onDownloadAttachment(attachment) {
    return this.downloadAttachment(this.jurisdictionId, attachment);
  }

  addTargetBlank(val) {
    if (isString(val)) {
      return val.replace(/<a /g, '<a target="_blank" ');
    }
    return val;
  }
}

export default class AnnouncementsWidgetContentComponent {
  constructor() {
    this.template = template;
    this.controller = AnnouncementsWidgetContentController;
    this.bindings = {
      items: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/announcements-widget-content-component.js